import { render, staticRenderFns } from "./exportCountryYearReportCopy2.vue?vue&type=template&id=66c7e80d&scoped=true"
import script from "./exportCountryYearReportCopy2.vue?vue&type=script&lang=js"
export * from "./exportCountryYearReportCopy2.vue?vue&type=script&lang=js"
import style0 from "./exportCountryYearReportCopy2.vue?vue&type=style&index=0&id=66c7e80d&prod&scoped=true&lang=css"
import style1 from "./exportCountryYearReportCopy2.vue?vue&type=style&index=1&id=66c7e80d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c7e80d",
  null
  
)

export default component.exports